import { I18n } from '@front/volcanion'
import GeoUtils from '@front/volcanion/utils/geo'

class Callbacks {
  static handleSwapAddress(source, destination, setFormValues) {
    return function swapAddress() {
      setFormValues([
        { field: 'source', value: destination },
        { field: 'destination', value: source },
      ])
    }
  }
  static handleSetFavoriteAddressHandler(openNotification, owner, address, favorite, setFavoriteAddress, toggleFavorite) {
    return async function handleSetFavoriteAddress() {
      try {
        await toggleFavorite({ owner, address: address, favorite: !favorite })
        openNotification(I18n.t(`toast.address.success.${!!favorite ? 'unfavorite' : 'favorite'}`), { variant: 'success' })
        setFavoriteAddress(!favorite)
      } catch (err) {
        openNotification(I18n.t(`toast.address.error.${!favorite ? 'unfavorite' : 'favorite'}`), { variant: 'error' })
      }
    }
  }
  static handleReplaceCommentHandler(openNotification, save_comment, setSaveComment, comment, address) {
    return function handleReplaceComment() {
      if (!save_comment) {
        if (!!address?.address_id && !!address?.comment)
          openNotification(I18n.t('toast.comment.success.replaced', { old_comment: address?.comment, comment }), { variant: 'success' })
        else
          openNotification(I18n.t('toast.comment.success.saved', { comment }), { variant: 'success' })
      }
      else if (!!address?.address_id && !!address?.comment)
        openNotification(I18n.t('toast.comment.cancel.replaced'))
      else
        openNotification(I18n.t('toast.comment.cancel.saved'))
      setSaveComment(!save_comment)
    }
  }
  static handleOnAddressResolve(setFormValues, setFormState, prefix, source, destination) {
    return function addressResolve(details) {
      const prefix_field = prefix === 'source' ? 'src' : 'dest'
      const isSame = !!source && !!destination && GeoUtils.isSameAddress(source, destination)

      setFormState({
        [`details.${prefix}`]: details,
        [`favorite_address.${prefix}`]: details?.favorite,
        [`save_comment.${prefix}`]: !!details?.comment
      })

      setFormValues(_.compact([
        { field: `info.${prefix_field}_comment`, value: details?.comment },
        prefix === 'source' && { field: 'poi', value: details?.poi },
        !!isSame && { field: 'source', meta: { error: true, field_error: I18n.t('error.address.same') } },
        !!isSame && { field: 'destination', meta: { error: true, field_error: I18n.t('error.address.same') } }
      ]))

      if (details?.poi_id === source?.poi_id) {
        setFormState({
          meeting_point: {
            translated: details?.meeting_point_translated,
            trkey: details?.meeting_point_trkey
          },
          driver_instruction: {
            translated: details?.driver_instruction_translated,
            trkey: details?.driver_instruction_trkey
          }
        })
      }
    }
  }
  static guestChangeHandler(setFormValues, companyuser, prefix) {
    return function guestChange(value) {
      const full_name = _.compact([companyuser?.user?.info?.first_name, companyuser?.user?.info?.last_name]).join(' ') || companyuser?.user?.customerinfo?.name
      const address_field = prefix === 'source' ? 'src' : 'dest'
      setFormValues([
        { field: 'guest', value },
        { field: `loads.${address_field}_phone`, value: !!value ? undefined : companyuser?.user?.auth?.gsm },
        { field: `loads.${address_field}_contact`, value: !!value ? undefined : full_name }
      ])
    }
  }
  static handleIsReservationinfoChangeHandler(poi, setFormState) {
    return function handleIsReservationinfoChange(value) {
      if (!value) {
        setFormState({
          meeting_point: {
            translated: poi?.meeting_point_translated,
            trkey: poi?.meeting_point_trkey
          },
          driver_instruction: {
            translated: poi?.driver_instruction_translated,
            trkey: poi?.driver_instruction_trkey
          }
        })
      }
      else if (!!value) {
        setFormState({
          meeting_point: {
            translated: poi?.type?.reservationinfo?.arrival_translated,
            trkey: poi?.type?.reservationinfo?.arrival_trkey
          },
          driver_instruction: {
            translated: poi?.type?.reservationinfo?.arrival_translated,
            trkey: poi?.type?.reservationinfo?.arrival_trkey
          }
        })
      }
    }
  }
}

export default Callbacks
